/** @format */

'use client';

import { useCallback, useState } from 'react';
// import { useRouter } from "next/navigation";
import { useSearchParams } from 'src/hooks/use-search-params';
import { useServerError } from 'src/hooks/use-server-error';
// import { zodResolver } from "@hookform/resolvers/zod";
import { yupResolver } from '@hookform/resolvers/yup';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { Eye as EyeIcon } from '@phosphor-icons/react/dist/ssr/Eye';
import { EyeSlash as EyeSlashIcon } from '@phosphor-icons/react/dist/ssr/EyeSlash';
import { Controller, useForm } from 'react-hook-form';
import * as Yup from 'yup';

import { Dialog, DialogActions, TextField } from '@mui/material';
import { getTime } from 'date-fns';
import { debounce } from 'lodash';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';

import { useCompleteRegisterMutation } from 'src/api/account-api';
import { DialogContentStyled, DialogTitleWithButtonClose } from 'src/components/modals';
import { refreshKeyConfig } from 'src/config';
import { setRefesh } from 'src/store/app-slice';

const validationSchema = Yup.object({
  // ## thay pattern password manh hơn
  password: Yup.string()
    .required('Vui lòng nhập mật khẩu')
    .min(7, 'Mật khẩu tối thiểu 7 kí tư')
    .max(255, 'Mật khẩu quá dài')

    .label('Password')
});
const initialValues = {
  displayName: '',
  phoneNumber: '',
  password: ''
};

const AccountComplete = () => {
  const dispatch = useDispatch();

  const searchParams = useSearchParams();
  const { processError } = useServerError();
  const returnTo = searchParams.get('returnTo');

  const [formSubmiting, setFormSubmiting] = useState(false);
  const [showPassword, setShowPassword] = useState();

  const [completeRegister] = useCompleteRegisterMutation();

  const {
    control,
    formState: { errors, isDirty },
    handleSubmit
  } = useForm({
    mode: 'onChange',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema)
  });

  const debounceSave = useCallback(
    debounce(async (values) => {
      try {
        await completeRegister(values).unwrap();

        toast.success('Chào mừng bạn đến với nhieuxe.vn');
        dispatch(
          setRefesh({
            [refreshKeyConfig.pageReload]: getTime(new Date())
          })
        );
      } catch (error) {
        console.log('debounceSave error', error);
        processError(error);
      } finally {
        setFormSubmiting(false);
      }
    }, 200),
    [returnTo]
  );

  const onSubmit = async (values) => {
    setFormSubmiting(true);
    await debounceSave(values);
  };

  const handleClose = async () => {
    setFormSubmiting(true);
    await debounceSave({});
  };

  return (
    <Dialog
      open={true}
      onClose={(_event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose();
        }
      }}
    >
      <DialogTitleWithButtonClose title="Hoàn tất đăng kí" onClose={handleClose} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContentStyled size="small">
          <Controller
            name="displayName"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                margin="dense"
                // variant='standard'
                fullWidth
                label="Họ và tên"
                error={!!errors.phoneNumber}
                helperText={errors?.phoneNumber?.message}
              />
            )}
          />

          <Controller
            name="password"
            control={control}
            render={({ field }) => (
              // <TooltipError errorMessage={errors?.password?.message}>
              <TextField
                {...field}
                margin="dense"
                fullWidth
                type={showPassword ? 'text' : 'password'}
                label="Mật Khẩu*"
                error={!!errors.password}
                helperText={errors?.password?.message}
                InputProps={{
                  endAdornment: showPassword ? (
                    <EyeIcon
                      cursor="pointer"
                      fontSize="var(--icon-fontSize-lg)"
                      onClick={() => {
                        setShowPassword(false);
                      }}
                    />
                  ) : (
                    <EyeSlashIcon
                      cursor="pointer"
                      fontSize="var(--icon-fontSize-lg)"
                      onClick={() => {
                        setShowPassword(true);
                      }}
                    />
                  )
                }}
              />
            )}
          />
        </DialogContentStyled>
        <DialogActions
          sx={{
            justifyContent: 'space-around'
          }}
        >
          <Stack direction="row" columnGap={1}>
            <Button variant="contained" color="inherit" onClick={handleClose}>
              Cập nhật sau
            </Button>

            <Button type="submit" variant="contained" disabled={!isDirty || formSubmiting}>
              Hoàn thành
            </Button>
          </Stack>
        </DialogActions>
      </form>
    </Dialog>
  );
};
export default AccountComplete;
